/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module heading
 */
export { default as Heading } from './heading.js';
export { default as HeadingEditing } from './headingediting.js';
export { default as HeadingUI } from './headingui.js';
export { default as HeadingButtonsUI } from './headingbuttonsui.js';
export { default as Title } from './title.js';
import './augmentation.js';
